module.exports = __webpack_public_path__ + "img/1723596781813-1ac2ee39-1298-4beb-9a7b-6f791dd07ee8.jpeg.0aafceda.webp";